
import { Link } from 'react-router-dom';

export default function NightComboBanner() {
  return (
    <section className="py-16 px-4 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/165d967a66245e6498071c4481f55efb.jpg"
          alt="Tokyo Night Combo Experience"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950/90 via-gray-950/75 to-gray-950/90"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
            <i className="ri-beer-line text-amber-400 text-lg"></i>
            <span className="text-white text-sm font-medium">New Combo Experience</span>
            <i className="ri-mic-fill text-pink-400 text-lg"></i>
          </div>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Experience Tokyo Night<br />in One Evening
          </h2>

          <p className="text-xl text-amber-300 font-semibold mb-3">
            Izakaya + Karaoke · The Ultimate Tokyo Night Out
          </p>

          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            Start with authentic local izakaya vibes, then sing your heart out at a karaoke box.<br />
            All with a friendly local guide — no stress, just pure fun.
          </p>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {[
              { icon: 'ri-beer-line', color: 'text-amber-400', label: 'Local Izakaya' },
              { icon: 'ri-add-line', color: 'text-white/40', label: '' },
              { icon: 'ri-mic-fill', color: 'text-pink-400', label: 'Karaoke Box' },
              { icon: 'ri-time-line', color: 'text-rose-300', label: '4–5 Hours' },
              { icon: 'ri-group-line', color: 'text-amber-300', label: 'Max 4 People' },
            ].filter(f => f.label).map((f, i) => (
              <div key={i} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <i className={`${f.icon} ${f.color}`}></i>
                <span className="text-white text-sm">{f.label}</span>
              </div>
            ))}
          </div>

          {/* Price */}
          <div className="inline-block mb-8">
            <div className="bg-gradient-to-r from-amber-900/60 to-pink-900/60 border border-amber-500/40 rounded-2xl px-8 py-4 backdrop-blur-sm">
              <p className="text-gray-400 text-sm mb-1">Combo Package (1–2 people)</p>
              <p className="text-white text-3xl font-extrabold">¥30,000<span className="text-lg font-normal text-white/60"> ~</span></p>
              <p className="text-white/50 text-xs mt-1">+¥5,000 per additional person (max 4)</p>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/tokyo-night-combo"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-pink-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-amber-600 hover:to-pink-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-moon-fill text-xl"></i>
              <span>View Details (English)</span>
            </Link>
            <Link
              to="/tokyo-night-combo-ja"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>日本語で見る</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
